var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.2,42.63v-0.03h25.19v-0.07c0.86-0.13,1.17-0.58,1.16-1.79c-0.07-12.11-0.04-24.23-0.04-36.34 c0-2.16-0.01-2.16-2.21-2.16c-15.97,0-31.95,0.01-47.92,0c-2.07,0-2.07-0.02-2.07,2.06c0,8.74,0,17.47,0,26.21 c0,3.62-0.01,7.24,0,10.86c0,0.36-0.03,0.71,0.11,0.95v0.28h0.39c0.13,0.04,0.28,0.06,0.49,0.06C21.6,42.6,29.9,42.63,38.2,42.63z  M15.6,6.69c0-1.81,0.33-2.14,2.09-2.14c13.81,0,27.62,0,41.43,0c1.78,0,2.11,0.33,2.11,2.11c0.01,9.03,0.01,18.06,0,27.09 c0,1.83-0.25,2.06-2.11,2.07c-0.94,0.01-1.88,0.06-2.81-0.01H52.4c-0.29,0.08-0.7,0.01-1.04,0.03V35.8h-0.39 c-0.2,0.02-0.39,0.03-0.55,0h-3.79c-0.22,0.07-0.52,0.01-0.77,0.01c-9.37,0-18.73,0-28.1,0c-1.89,0-2.16-0.26-2.16-2.19 C15.59,24.65,15.59,15.66,15.6,6.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55,49.48v2.58h1.01c0.81,0,1.37-0.57,1.37-1.29v-0.01c0-0.73-0.56-1.29-1.37-1.29H61.55z M63.34,50.77L63.34,50.77 c0,0.46-0.31,0.78-0.78,0.78h-0.44v-1.56h0.44C63.03,49.99,63.34,50.31,63.34,50.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.48,51.6c-0.3,0-0.54-0.12-0.77-0.31l-0.34,0.4c0.31,0.28,0.71,0.41,1.1,0.41c0.56,0,0.95-0.29,0.95-0.8v-0.01 c0-0.45-0.3-0.64-0.82-0.78c-0.45-0.12-0.56-0.17-0.56-0.34v-0.01c0-0.12,0.11-0.22,0.33-0.22s0.44,0.1,0.67,0.25l0.3-0.43 c-0.26-0.21-0.58-0.33-0.96-0.33c-0.53,0-0.9,0.31-0.9,0.78v0.01c0,0.51,0.34,0.66,0.86,0.79c0.43,0.11,0.52,0.18,0.52,0.33v0.01 C54.86,51.51,54.72,51.6,54.48,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.14,49.96c0.26,0,0.46,0.11,0.66,0.29l0.36-0.42c-0.24-0.24-0.53-0.4-1.02-0.4c-0.79,0-1.35,0.6-1.35,1.34v0.01 c0,0.74,0.56,1.33,1.33,1.33c0.5,0,0.79-0.18,1.06-0.46l-0.36-0.37c-0.2,0.18-0.38,0.3-0.68,0.3c-0.44,0-0.75-0.37-0.75-0.81v-0.01 C56.39,50.32,56.71,49.96,57.14,49.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,52.06l0.24-0.58h1.09l0.24,0.58h0.59l-1.11-2.6h-0.52l-1.11,2.6H64.61z M65.4,50.14l0.34,0.84h-0.69L65.4,50.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.05,49.46h-0.52l-1.11,2.6H59l0.24-0.58h1.09l0.24,0.58h0.59L60.05,49.46z M59.44,50.98l0.34-0.84l0.34,0.84H59.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.32,19.52c0.69-1.26,1.88-1.51,3.04-0.68c0.74,0.53,1.36,1.21,2.04,1.83c2.73,2.49,5.73,2.21,7.94-0.73 c0.17-0.23,0.33-0.47,0.51-0.7c1.52-1.95,3.53-1.98,5.06-0.04c0.68,0.87,1.26,1.83,1.96,2.68c1.08,1.33,2.5,2.07,4.22,2.05 c2.2,0.07,3.49-1.2,4.56-2.86c0.96-1.49,2-2.93,2.89-4.46c0.22-0.38,0.19-1.33-0.04-1.46c-0.43-0.24-1.32-0.31-1.62-0.03 c-0.83,0.78-1.5,1.74-2.14,2.69c-0.57,0.83-0.94,1.8-1.53,2.61c-1.08,1.49-2.62,1.67-3.98,0.43c-0.7-0.64-1.36-1.41-1.8-2.24 c-1.89-3.57-7.03-4.77-9.86-0.32c-1.42,2.23-2.85,2.21-4.87,0.39c-0.92-0.83-1.86-1.71-2.95-2.28c-1.96-1.02-4.63-0.05-5.47,1.95 c-0.22,0.52-0.13,1.56,0.24,1.86C22.22,20.8,22.86,20.36,23.32,19.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.31,31.31V7.07H17.54v24.74h41.77V31.31z M58.31,30.81H18.54V8.07h39.77V30.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.01,
    y: 44.92,
    width: 8.9,
    height: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.91,49.65h-21.8c-0.94,0-1.71,0.76-1.71,1.71v1.87h25.98v-1.1C51.38,50.75,50.28,49.65,48.91,49.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.72,70.37h-2.21V54.8h-15.3v23.09h15.3v-0.5v-2.34h2.21v2.84h9.04v-0.5V54.8h-9.04V70.37z M11.21,55.8h13.3v21.09 h-13.3V55.8z M25.51,73.22V72.2h2.21v1.02H25.51z M28.72,55.8h7.04v21.09h-7.04V55.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.09,
    y: 58.32,
    width: 4.31,
    height: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.09,
    y: 63.87,
    width: 4.31,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.91,77.89h9.04v-0.5V54.8h-9.04V77.89z M38.91,55.8h7.04v21.09h-7.04V55.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.28,
    y: 58.32,
    width: 4.31,
    height: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.28,
    y: 63.87,
    width: 4.31,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.85,77.89h9.04v-0.5V54.8h-9.04V77.89z M48.85,55.8h7.04v21.09h-7.04V55.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.22,
    y: 58.32,
    width: 4.31,
    height: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.22,
    y: 63.87,
    width: 4.31,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,54.8v23.09h9.04v-0.5V54.8H57.53z M58.53,55.8h7.04v21.09h-7.04V55.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 58.32,
    width: 4.31,
    height: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 63.87,
    width: 4.31,
    height: 2.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScada);
export default __webpack_public_path__ + "static/media/Scada.343d0da93d58ac382cf8d94815fbeaae.svg";
export { ForwardRef as ReactComponent };